<template>
  <div>
    <el-dialog v-if="visible" :close-on-click-modal="false" title="Item Transaction Info" :model-value="visible"
      @update:modelValue="visible = $event" :before-close="handleClose" width="30%">

      <el-form :model="itemTransaction" :rules="rules" ref="formRef" label-width="130px" size="small">
        <el-form-item v-show="itemTransaction.itnxNo" label="Transaction No">
          <el-input v-model="itemTransaction.itnxNo" disabled style="width: 240px" />
        </el-form-item>
        <el-form-item label="Customer" prop="customerName">
          <div style="width: 240px; cursor: pointer" @click="modal.openCustomer()">
            <el-input v-model="itemTransaction.customerName" placeholder="Click to select" readonly />
          </div>
        </el-form-item>
        <el-form-item label="Branch" prop="place">
          <el-select v-model="itemTransaction.place" placeholder="Select" style="width: 240px">
            <el-option v-for="item in branchList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="In/Out" prop="io">
          <el-select v-model="itemTransaction.io" style="width: 160px">
            <el-option v-for="item in itemIoType.toList()" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="For" prop="for">
          <el-select v-model="itemTransaction.tnxFor" style="width: 160px">
            <el-option v-for="item in transactionFor.toList()" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="Of" prop="of">
          <el-select v-model="itemTransaction.of" placeholder="Select" style="width: 160px">
            <el-option v-for="item in ofOptions.toList().filter(o => [1, 2].includes(o.id))" :key="item.id"
              :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="Category" prop="categoryId">
          <el-cascader v-model="selectedCategoryValue" :options="categoryOptions"
            :props="{ checkStrictly: false, label: 'label', value: 'value' }" filterable clearable
            :disabled="itemTransaction.of == ofOptions.Customer.id" :filter-method="customFilter" show-all-levels
            @change="handleCategoryValueChange" style="width: 280px" />
        </el-form-item>
        <el-form-item v-if="itemTransaction.of == ofOptions.Customer.id" label="SKU" prop="sku">
          <div style="width: 240px; cursor: pointer" @click="modal.openSku()">
            <el-input v-model="itemTransaction.sku" placeholder="Click to select" readonly />
          </div>
        </el-form-item>
        <el-form-item v-if="itemTransaction.of == ofOptions.Customer.id" label="Attribute" prop="attribute">
          <el-select v-model="itemTransaction.attributeCategoryId" placeholder="Select" remote @focus="fetchAttr"
            @change="handleAttrbuteChange" style="width: 240px">
            <el-option v-for="item in attributeList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item v-show="selectedAttributes.length > 0" label="Variants" prop="variants">
          <el-card shadow="never" style="width: 100%">
            <div style="margin-bottom: 8px" v-for="(item, index) in selectedAttributes" :key="index">
              <el-row :gutter="8" align="middle">
                <el-col :span="8">
                  <div style="text-align: right; padding-right: 8px">{{ item.name }}:</div>
                </el-col>
                <el-col :span="16">
                  <el-select v-if="item.inputType === 1" v-model="selectedAttributes[index].value" style="width: 100%">
                    <el-option v-for="opt in getParamInputList(item.inputList)" :key="opt" :label="opt" :value="opt" />
                  </el-select>
                  <el-input v-else v-model="selectedAttributes[index].value" style="width: 100%" />
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-form-item>
        <el-form-item v-show="selectedParameters.length > 0" label="Parameters" prop="parameters">
          <el-card shadow="never" style="width: 100%">
            <div style="margin-bottom: 8px" v-for="(item, index) in selectedParameters" :key="index">
              <el-row :gutter="8" align="middle">
                <el-col :span="8">
                  <div style="text-align: right; padding-right: 8px">{{ item.name }}:</div>
                </el-col>
                <el-col :span="16">
                  <el-select v-if="item.inputType === 1" v-model="selectedParameters[index].value" filterable
                    allow-create default-first-option placeholder="Select or type" style="width: 100%">
                    <el-option v-for="opt in getInputListArr(item.inputList)" :key="opt" :label="opt" :value="opt" />
                  </el-select>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-form-item>
        <el-form-item label="Quality">
          <el-input type="textarea" v-model="manualQuality" style="width: 280px" :rows="2" />
        </el-form-item>
        <el-form-item label="Reference">
          <el-input v-model="itemTransaction.reference" disabled style="width: 240px" />
        </el-form-item>
        <el-form-item label="Sub References">
          <el-input type="textarea" v-model="itemTransaction.subReferences" disabled style="width: 280px" :rows="2" />
        </el-form-item>
        <el-form-item label="Description" prop="description">
          <el-input type="textarea" v-model="itemTransaction.description" style="width: 280px" :rows="2" />
        </el-form-item>
        <el-form-item label="Wt Unit" prop="wt">
          <el-select v-model="itemTransaction.wtUnit" placeholder="Select" style="width: 160px">
            <el-option v-for="item in wtUnitOptions.toList()" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="itemTransaction.wtUnit == 3" label="Weight" prop="wtStr">
          <el-row :gutter="6" style="width: 280px">
            <el-col :span="8"><el-input type="number" v-model="rawWt.totalK" placeholder="ကျပ်" @blur="formatGold"
                style="width: 100%" /></el-col>
            <el-col :span="8"><el-input type="number" v-model="rawWt.totalP" placeholder="ပဲ" @blur="formatGold"
                style="width: 100%" /></el-col>
            <el-col :span="8"><el-input type="number" v-model="rawWt.totalY" placeholder="ရွေး" @blur="formatGold"
                style="width: 100%" /></el-col>
          </el-row>
        </el-form-item>
        <el-form-item v-else label="Weight" prop="wtStr">
          <el-input type="number" v-model="rawWt.totalG" :placeholder="wtPlaceholder" @blur="formatGold"
            style="width: 160px" />
        </el-form-item>
        <el-form-item label="Quantity" prop="qty">
          <el-row :gutter="6" style="width: 200px">
            <el-col :span="14"><el-input type="number" min="1" step="1" v-model="itemTransaction.qty"
                style="width: 100%" /></el-col>
            <el-col :span="10">
              <el-select v-model="itemTransaction.qtyUnit" placeholder="Unit" style="width: 100%">
                <el-option v-for="item in qtyUnitOptions.toList()" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="Note" prop="note">
          <el-input type="textarea" v-model="itemTransaction.note" style="width: 280px" :rows="2" />
        </el-form-item>
      </el-form>

      <template #footer>
        <el-button @click="modal.closeItemTransaction(); visible = false" size="small">Cancel</el-button>
        <el-button type="primary" @click="handleDialogConfirm" size="small">Confirm</el-button>
      </template>
      <div v-if="isDialogDisabled" class="dialog-overlay"></div>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, computed, watch, nextTick } from 'vue'
import { ElMessageBox } from 'element-plus'
import { itemIoType, transactionFor, qtyUnitOptions, wtUnitOptions, ofOptions } from '@/utils/constants'
import { getAllCategoryList, getCategoryNameById, getCategoryIdPath, getAttributeList, getInventoryType } from '@/utils/helpers'
import { useModalStore } from '@/stores/modal'
import { useShopDataStore } from '@/stores/shopData'
import { useUserStore } from '@/stores/user'
import { defaultItemTransaction, defaultItemTransactionRawWt as defaultRawWt } from './defaults'
import { kpyToKyat } from '@/composables/useGoldWeight'

const modal = useModalStore()
const shopDataStore = useShopDataStore()
const userStore = useUserStore()
const formRef = ref(null)

const visible = ref(false)
const isDialogDisabled = ref(false)
const isInitializing = ref(false)
const branchList = ref([])
const itemTransaction = ref({ ...defaultItemTransaction })
const categoryOptions = ref([])
const selectedCategoryValue = ref([])
const selectedAttributes = ref([])
const selectedParameters = ref([])
const rawWt = ref({ ...defaultRawWt })
const manualQuality = ref('')
const attributeList = ref([])

const rules = computed(() => ({
  sku: [{ required: true, message: 'This field is required', trigger: 'change' }],
  qty: [
    { required: true, message: 'This field is required', trigger: 'change' },
    { validator: (_, val, cb) => (parseFloat(val) > 0 ? cb() : cb(new Error('Must be greater than 0'))), trigger: 'change' },
  ],
  wtStr: [
    { required: true, message: 'This field is required', trigger: ['change', 'blur'] },
    {
      validator: (_, val, cb) => {
        if (itemTransaction.value.wtUnit == 3) {
          const parts = String(val).split('-').map(Number)
          return parts[0] + parts[1] / 16 + parts[2] / (16 * 7.5) > 0 ? cb() : cb(new Error('Must be greater than 0'))
        }
        return parseFloat(val) > 0 ? cb() : cb(new Error('Must be greater than 0'))
      },
      trigger: ['change', 'blur'],
    },
  ],
  place: [{ required: true, message: 'This field is required', trigger: 'change' }],
  categoryId: [{ required: itemTransaction.value.of === ofOptions.GD.id, message: 'This field is required', trigger: 'change' }],
}))

const wtPlaceholder = computed(() => {
  const unit = wtUnitOptions.fromId(itemTransaction.value.wtUnit)
  return unit ? unit.name : ''
})

// Watch customer selection
watch(() => modal.customer.selected, (val) => {
  if (val && visible.value) {
    itemTransaction.value.customerName = val.name
    itemTransaction.value.customerId = val.id
  }
})

// Reset category and SKU when branch or of changes
watch(() => itemTransaction.value.place, () => {
  if (isInitializing.value) return
  selectedCategoryValue.value = []
  itemTransaction.value.parentCategoryId = null
  itemTransaction.value.categoryId = null
  itemTransaction.value.categoryName = null
  itemTransaction.value.sku = null
})

watch(() => itemTransaction.value.of, () => {
  if (isInitializing.value) return
  selectedCategoryValue.value = []
  rawWt.value = { ...defaultRawWt }
  resetParamAttribute()
  manualQuality.value = ''
  itemTransaction.value = {
    ...itemTransaction.value,
    parentCategoryId: null,
    categoryId: null,
    categoryName: null,
    sku: null,
    attributeCategoryId: null,
    description: null,
    quality: null,
    reference: null,
    subReferences: null,
    wtUnit: null,
    wt: null,
    wtStr: null,
    qty: null,
    qtyUnit: null,
    note: null,
  }
  nextTick(() => formRef.value?.clearValidate())
})

// Watch sku selection
watch(() => modal.sku.selected, (val) => {
  if (val && visible.value) {
    itemTransaction.value.sku = val.code
    itemTransaction.value.categoryId = val.categoryId
    itemTransaction.value.categoryName = val.categoryName
    itemTransaction.value.parentCategoryId = val.parentCategoryId
  }
})

// Watch selectedAttributes/selectedParameters for auto-quality
watch([selectedAttributes, selectedParameters], () => {
  if (isInitializing.value) return
  let quality = ''
  selectedAttributes.value.forEach(attr => { if (attr.value) quality += attr.value + ' ' })
  if (selectedAttributes.value.length) quality += '\n'
  selectedParameters.value.forEach(param => { if (param.value) quality += param.value + ' ' })
  manualQuality.value = quality.trim()
}, { deep: true })

watch(() => modal.itemTransaction.visible, async (val) => {
  if (val) {
    try {
      isInitializing.value = true
      resetParamAttribute()
      branchList.value = shopDataStore.branches
      categoryOptions.value = getAllCategoryList(shopDataStore.categories, ['Golds', 'Diamonds', 'Gems', 'Big Stones', 'Stocks', 'Metals'])
      itemTransaction.value = { ...defaultItemTransaction }
      selectedCategoryValue.value = []
      rawWt.value = { ...defaultRawWt }
      manualQuality.value = ''

      const params = modal.itemTransaction.data
      if (params) {
        itemTransaction.value = { ...params }
        manualQuality.value = itemTransaction.value.quality
        selectedCategoryValue.value = getCategoryIdPath(categoryOptions.value, itemTransaction.value.parentCategoryId, itemTransaction.value.categoryId, itemTransaction.value.categoryName)
        if (itemTransaction.value.wtUnit == 3 && itemTransaction.value.wtStr != null) {
          const lst = itemTransaction.value.wtStr.split('-')
          rawWt.value.totalK = lst[0]; rawWt.value.totalP = lst[1]; rawWt.value.totalY = lst[2]
        } else {
          rawWt.value.totalG = itemTransaction.value.wtStr
        }
      } else {
        itemTransaction.value.place = userStore.defaultBranch?.id
      }
      formatGold()
      visible.value = true
    } catch (e) {
      // error handled by request interceptor
    } finally {
      nextTick(() => { isInitializing.value = false })
    }
  } else {
    visible.value = false
  }
}, { immediate: true })

function resetParamAttribute() {
  selectedParameters.value = []
  selectedAttributes.value = []
}

function formatGold() {
  if (itemTransaction.value.wtUnit == 3) {
    itemTransaction.value.wt = kpyToKyat({ kyat: rawWt.value.totalK, pal: rawWt.value.totalP, yway: rawWt.value.totalY }).wt
    itemTransaction.value.wtStr = `${rawWt.value.totalK || 0}-${rawWt.value.totalP || 0}-${rawWt.value.totalY || 0}`
  } else {
    const temp = parseFloat(rawWt.value.totalG) || 0
    itemTransaction.value.wt = temp
    itemTransaction.value.wtStr = temp
  }
  if (visible.value) nextTick(() => formRef.value?.validateField('wtStr').catch(() => { }))
}

async function fetchAttr() {
  if (attributeList.value.length > 0) return
  attributeList.value = [{ id: '', name: '' }, ...(shopDataStore.attributes || [])]
}

async function handleAttrbuteChange(value) {
  resetParamAttribute()
  if (!value) return
  try {
    isDialogDisabled.value = true
    const result1 = await getAttributeList(0, value)
    const result2 = await getAttributeList(1, value)
    selectedAttributes.value = result1.selectedAttributes
    selectedParameters.value = result2.selectedParameters
  } catch (e) {
    // error handled by request interceptor
  } finally {
    isDialogDisabled.value = false
  }
}

function customFilter(node, keyword) {
  return node.label?.toLowerCase().includes(keyword.toLowerCase())
}

function handleCategoryValueChange(value) {
  if (value && value.length >= 2) {
    itemTransaction.value.parentCategoryId = value[0]
    itemTransaction.value.categoryId = value[value.length - 1]
    itemTransaction.value.categoryName = getCategoryNameById(categoryOptions.value, itemTransaction.value.categoryId, value.length)
    shopDataStore.defaultSkuList.forEach(sku => {
      if (sku.of == itemTransaction.value.of && sku.place == itemTransaction.value.place && sku.parentCategoryId === itemTransaction.value.parentCategoryId) {
        itemTransaction.value.sku = sku.code
        return
      }
    })
  } else {
    itemTransaction.value.parentCategoryId = null
    itemTransaction.value.categoryId = null
    itemTransaction.value.categoryName = null
  }
  formRef.value?.validateField('categoryId')
}

function getInputListArr(inputList) { return inputList.split(',') }
function getParamInputList(inputList) { return inputList.split(',') }

function handleClose(done) {
  formRef.value?.clearValidate()
  modal.closeItemTransaction()
  done()
}

async function handleDialogConfirm() {
  const valid = await formRef.value.validate().catch(() => false)
  if (!valid) return

  ElMessageBox.confirm(`Are you sure you want to submit this transaction?`, 'Warning', {
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel',
    type: 'warning'
  }).then(async () => {
    itemTransaction.value.branchCode = branchList.value.find(b => b.id === itemTransaction.value.place)?.branchCode
    const isGD = itemTransaction.value.of === ofOptions.GD.id
    itemTransaction.value.inventoryType = getInventoryType(isGD ? selectedCategoryValue.value : null, isGD ? null : itemTransaction.value.sku)

    // if (!itemTransaction.value.categoryName) itemTransaction.value.categoryName = itemTransaction.value.quality
    // if (!itemTransaction.value.reference) itemTransaction.value.reference = ''
    itemTransaction.value.quality = manualQuality.value

    // Notify caller via modal store
    modal.itemTransaction.data = { ...itemTransaction.value, _validated: true }
    modal.closeItemTransaction()
    visible.value = false
  }).catch(() => { })
}
</script>

<style>
.dialog-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.5);
  z-index: 1000;
  cursor: not-allowed;
}
</style>
